module.exports = __webpack_public_path__ + "static/img/hy@2x.da9042a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hy@2x.png
// module id = uQB9
// module chunks = 1